import { render, staticRenderFns } from "./ComparisonChart.vue?vue&type=template&id=4f03322d&scoped=true&"
import script from "./ComparisonChart.vue?vue&type=script&lang=js&"
export * from "./ComparisonChart.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonChart.vue?vue&type=style&index=0&id=4f03322d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03322d",
  null
  
)

export default component.exports